import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/social-security-calculator',
  component: () => import('../../routes/SocialSecurityCalculator.svelte'),
  card: {
    id: 'social-security-calculator',
    title: 'Social Security Calculator',
    description: 'Estimate your Social Security retirement benefits based on earnings history and claiming age.',
    icon: 'account_balance',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/social-security-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Social Security Calculator – Estimate Your Retirement Benefits',
    description: 'Free Social Security calculator estimates your retirement benefits based on earnings history. Compare claiming ages, spousal benefits, and lifetime payouts.',
  },
};

export default meta;
